<template>
  <div class="classlayout">
    <el-main>
      <div class="div2">
        <div class="div2-br">
          <span>学段：</span>
          <div class="btn">
            <el-radio-group v-model="stageId" @change="changeStage">
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item, index) in stages"
                :key="index"
                >
                  {{ item.name }}
                </el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br" v-if="stageId !== 2">
          <span>栏目：</span>
          <div class="btn">
            <el-radio-group
              v-model="columnId"
              @change="changeColumn"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item, index) in columns"
                :key="index"
              >
                {{ item.name }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <el-table
        :data="links"
        :height="height"
        v-loading="loading"
        header-row-class-name="header-row-class-name"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="name" label="新类型"></el-table-column>
        <el-table-column prop="oldPaperTypeNames" label="老类型"></el-table-column>
        <el-table-column prop="keyword" label="关键词"></el-table-column>
        <el-table-column prop="excludeKeyword" label="排除关键词"></el-table-column>
        <el-table-column prop="gradeNames" label="年级"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="addMap(scope.row, false)"
              >
              关联
              </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑框 -->
      <map-dialog
        v-model="classDialogVisible"
        :rowData="rowData"
        :pStages="stages"
        @success="editSuccess"
      >
      </map-dialog>
    </el-main>
  </div>
</template>
<script type="text/babel">
import shijuanService from "@/service/shijuanService";
import mapDialog from "./edit-dialog/map";
import commonService from "@/service/commonService";
import { tagMixins } from "./mixins/tagMixins";

export default {
  name: "shijuanTypeLink",
  mixins: [tagMixins],
  components: {
    mapDialog,
  },
  data() {
    return {
      classDialogVisible: false,
      height: this.SysConstant.winHeight - 280,
      loading: false,
      mapData: [],
      rowData: {}
    };
  },
  async mounted() {
    // 查询
    await this.getMaterial();
    await this.getStage();
    await this.getColumn();
    await this.getColumnType();
    this.getMap();
  },
  methods: {
    async changeStage() {
      await this.changeTag('stageId')
      this.getMap();
    },
    async changeColumn() {
      await this.changeTag('columnId')
      this.getMap();
    },

    async getMap() {
      try {
        let data = await shijuanService.shijuan_get_type_map({
          stageId: this.stageId,
          columnId: this.columnId
        });
        // 转obj
        let obj = {};
        for (let i = 0; i < data.length; i++) {
          obj[data[i].newPaperTypeId] = data[i];
        }
        if (data.length > 0) {
          // 这里做个数据处理
          this.links = this.links.filter(item => {
            return item.used;
          }).map(item => {
            let id = item.detailType.id;
            if (obj[id]) {
              return {
                ...item,
                mapId: obj[id].id,
                oldPaperTypeId: obj[id].oldPaperTypeId ? obj[id].oldPaperTypeId.split(',').map(item => {
                  return +item;
                }) : [],
                keyword: obj[id].keyword || '',
                excludeKeyword: obj[id].excludeKeyword || '',
                oldPaperTypeNames: obj[id].oldPaperTypeNames || '',
                gradeNames: obj[id].gradeNames,
                gradeId: obj[id].gradeId ? obj[id].gradeId.split(',').map(item => {
                  return +item;
                }) : []
              }
            }
            return item;
          });
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async setMap(params) {
      try {
        await shijuanService.shijuan_set_type_map(params);
        this.$message.success(this.SysConstant.success);
        this.classDialogVisible = false;
        this.getMap();
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    addMap(row) {
      this.rowData = {
        stageId: this.stageId,
        columnId: this.columnId,
        gradeId: row.gradeId,
        newPaperTypeId: row.detailType.id,
        oldPaperTypeId: row.oldPaperTypeId || [],
        id: row.mapId || '',
        keyword: row.keyword,
        excludeKeyword: row.excludeKeyword
      };
      this.classDialogVisible = true;
    },
    async editSuccess(params) {
      params = {
        ...params,
        oldPaperTypeId: params.oldPaperTypeId.join(','),
        gradeId: params.gradeId.join(',')
      }
      this.setMap(params);
    },
  },
};
</script>
<style scoped>
.classlayout .div {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  height: 60px;
  margin-top: -10px;
  margin-bottom: 5px;
}
.classlayout .div {
  margin-top: -10px;
}
.classlayout .div .el-button {
  background-color: #00aaff;
  color: #fff;
  margin: 10px;
  float: left;
}
.classlayout .div2 {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  margin: 5px 0;
}
.classlayout .div2 .div2-br{
  overflow: hidden;
}

.classlayout .div2 span {
  margin: 0px 40px;
  float: left;
}
.classlayout .div2 .btn {
  float: left;
  width: 80%;
}
.classlayout .div2 .active {
  background-color: #00aaff;
  color: #fff;
}
</style>
<style type="text/css">
.classlayout .div2 .el-radio-button {
  margin: 10px 10px;
  border: none !important;
  border-radius: 4px !important;
}
.classlayout .el-radio-button__inner {
  border: 1px solid #dcdfe6;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/shijuan-manage/type-map.vue